import { useState } from "react";
import Layout, { Container } from "../components/layout";

const CreateTeam = () => {
  const [user, setUser] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    password: "",
    userType: "user",
    role: "user",
    employeeDetails: {
      employeeId: "",
      designation: "",
      department: "",
      joiningDate: "",
      employmentType: "full-time",
    },
    address: {
      name: "",
      phone: "",
      line1: "",
      line2: "",
      city: "",
      province: "",
      zip: "",
      country: "",
    },
    verificationDetails: {
      isPhoneVerified: false,
      isEmailVerified: false,
    },
    preferences: {
      notifications: {
        email: true,
        sms: true,
        push: true,
      },
      language: "en",
      theme: "light",
    },
  });

  const [permissions, setPermissions] = useState([
    { resource: "trainee", read: true, write: false, update: false, delete: false },
  ]);

  const handleUserChange = (e) => {
    const { name, value } = e.target;
    setUser((prev) => ({ ...prev, [name]: value }));
  };

  const handleEmployeeChange = (e) => {
    const { name, value } = e.target;
    setUser((prev) => ({
      ...prev,
      employeeDetails: { ...prev.employeeDetails, [name]: value },
    }));
  };

  const handleAddressChange = (e) => {
    const { name, value } = e.target;
    setUser((prev) => ({
      ...prev,
      address: { ...prev.address, [name]: value },
    }));
  };

  const handlePermissionChange = (index, e) => {
    const { name, type, checked, value } = e.target;
    const updatedPermissions = [...permissions];
    updatedPermissions[index][name] = type === "checkbox" ? checked : value;
    setPermissions(updatedPermissions);
  };

  const addPermission = () => {
    setPermissions([...permissions, { resource: "", read: false, write: false, update: false, delete: false }]);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const finalData = { ...user, permissions };
    console.log("Final User Data:", finalData);
    // You can now send `finalData` to your API
    alert("User created successfully!");
  };

  return (
    <Layout>
      <Container overflow="overflow-scroll">
        <div className="flex flex-col items-center p-6 bg-gray-50 min-h-screen">
          <div className="w-full max-w-4xl p-6 bg-white rounded-lg shadow-md">
            <h2 className="text-2xl font-bold mb-6">Create Team Member</h2>
            <form onSubmit={handleSubmit} className="space-y-6">

              {/* Basic Info */}
              <div className="grid grid-cols-2 gap-4">
                <input className="input" name="firstName" placeholder="First Name" onChange={handleUserChange} required />
                <input className="input" name="lastName" placeholder="Last Name" onChange={handleUserChange} required />
                <input className="input" name="email" type="email" placeholder="Email" onChange={handleUserChange} required />
                <input className="input" name="phone" placeholder="Phone" onChange={handleUserChange} />
                <input className="input" name="password" type="password" placeholder="Password" onChange={handleUserChange} required />
                <select className="input" name="userType" value={user.userType} onChange={handleUserChange}>
                  <option value="master">Master</option>
                  <option value="superadmin">Superadmin</option>
                  <option value="admin">Admin</option>
                  <option value="user">User</option>
                </select>
                <select className="input" name="role" value={user.role} onChange={handleUserChange}>
                  <option value="trainer">Trainer</option>
                  <option value="screener">Screener</option>
                  <option value="hr">HR</option>
                  <option value="master">Master</option>
                  <option value="user">User</option>
                  <option value="admin">Admin</option>
                  <option value="operations">Operations</option>
                  <option value="recruiter">Recruiter</option>
                </select>
              </div>

              {/* Employee Details */}
              <div>
                <h3 className="text-lg font-semibold">Employee Details</h3>
                <div className="grid grid-cols-2 gap-4">
                  <input className="input" name="employeeId" placeholder="Employee ID" onChange={handleEmployeeChange} />
                  <input className="input" name="designation" placeholder="Designation" onChange={handleEmployeeChange} />
                  <input className="input" name="department" placeholder="Department" onChange={handleEmployeeChange} />
                  <input className="input" name="joiningDate" type="date" onChange={handleEmployeeChange} />
                  <select className="input" name="employmentType" value={user.employeeDetails.employmentType} onChange={handleEmployeeChange}>
                    <option value="full-time">Full Time</option>
                    <option value="part-time">Part Time</option>
                    <option value="contract">Contract</option>
                  </select>
                </div>
              </div>

              {/* Address */}
              <div>
                <h3 className="text-lg font-semibold">Address</h3>
                <div className="grid grid-cols-2 gap-4">
                  <input className="input" name="name" placeholder="Full Name" onChange={handleAddressChange} />
                  <input className="input" name="phone" placeholder="Phone" onChange={handleAddressChange} />
                  <input className="input" name="line1" placeholder="Address Line 1" onChange={handleAddressChange} />
                  <input className="input" name="line2" placeholder="Address Line 2" onChange={handleAddressChange} />
                  <input className="input" name="city" placeholder="City" onChange={handleAddressChange} />
                  <input className="input" name="province" placeholder="Province" onChange={handleAddressChange} />
                  <input className="input" name="zip" placeholder="ZIP Code" onChange={handleAddressChange} />
                  <input className="input" name="country" placeholder="Country" onChange={handleAddressChange} />
                </div>
              </div>

              {/* Permissions */}
              <div>
                <h3 className="text-lg font-semibold">Permissions</h3>
                {permissions.map((perm, index) => (
                  <div key={index} className="flex items-center gap-4 mb-2">
                    <input
                      className="input"
                      name="resource"
                      placeholder="Resource Name"
                      value={perm.resource}
                      onChange={(e) => handlePermissionChange(index, e)}
                    />
                    {["read", "write", "update", "delete"].map((action) => (
                      <label key={action} className="flex items-center gap-1">
                        <input
                          type="checkbox"
                          name={action}
                          checked={perm[action]}
                          onChange={(e) => handlePermissionChange(index, e)}
                        />
                        {action.charAt(0).toUpperCase() + action.slice(1)}
                      </label>
                    ))}
                  </div>
                ))}
                <button type="button" className="text-blue-600 underline mt-2" onClick={addPermission}>
                  + Add Permission
                </button>
              </div>

              {/* Submit */}
              <button type="submit" className="w-full p-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition">
                Create User
              </button>
            </form>
          </div>
        </div>
      </Container>

      {/* Custom Tailwind Input */}
      <style jsx>{`
        .input {
          @apply w-full p-2 border border-gray-300 rounded focus:ring focus:ring-blue-200;
        }
      `}</style>
    </Layout>
  );
};

export default CreateTeam;